<template>
  <div class="add-discovery-campaign-city-and-price-setting">
    <ElForm
      ref="campaignModel"
      :model="campaignModel"
      :rules="campaignRules"
      label-position="top"
      @submit.native.prevent="submitForm"
    >
      <FormItemWithHint
        prop="targetedCpi"
        :label="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.TARGET_CPI')"
        :hint="$t('HINTS.DISCOVERY.TARGET_CPI')"
      >
        <ElInput
          v-model="campaignModel.targetedCpi"
          name="targetedCpi"
          type="number"
          min="0"
          required
        />
      </FormItemWithHint>

      <FormItemWithHint
        prop="budget"
        :label="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.BUDGET')"
        :hint="$t('HINTS.DISCOVERY.BUDGET')"
      >
        <ElInput
          v-model="campaignModel.budget"
          name="budget"
          type="number"
          min="0"
          required
        />
      </FormItemWithHint>

      <OptionalFormItem
        prop="dailyCap"
        :add-button-label="
          $t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.SET_DAILY_CAP')
        "
        :label="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.DAILY_CAP')"
        :hint="$t('HINTS.DISCOVERY.DAILY_CAP')"
        :initial-visibility="Boolean(campaignModel.dailyCap)"
        @remove="campaignModel.dailyCap = ''"
      >
        <ElInput
          v-model="campaignModel.dailyCap"
          name="dailyCap"
          type="number"
          min="0"
        />
      </OptionalFormItem>
    </ElForm>

    <BudgetError
      v-if="creditIsLessThanPrice"
      class="add-discovery-campaign-city-and-price-setting__budget-error"
    />

    <div class="row align-middle">
      <div class="columns">
        <ElButton
          type="text"
          class="add-discovery-campaign-city-and-price-setting__back"
          @click.native="$emit('back')"
        >
          <i class="el-icon-right" />
          {{ $t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.PREVIOUS_STEP') }}
        </ElButton>
      </div>
      <div class="columns shrink">
        <ElButton
          type="primary"
          native-type="submit"
          size="large"
          :loading="isLoading"
          :disabled="creditIsLessThanPrice"
          @click.native.prevent="submitForm"
        >
          {{ $t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.ADD_CAMPAIGN') }}
        </ElButton>
      </div>
    </div>
  </div>
</template>

<script>
import FormItemWithHint from '@@/common/FormItemWithHint';
import form from '@/mixins/form';
import requiredWithMessage from '@/utils/validation-rules/required';
import BudgetError from '../../../../common/BudgetError';
import OptionalFormItem from '@/components/common/OptionalFormItem.vue';

export default {
  name: 'AddDiscoveryCampaignCityAndPriceSetting',
  components: {
    FormItemWithHint,
    BudgetError,
    OptionalFormItem,
  },
  mixins: [form],
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    resetController: {
      type: Object,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      campaignModel: {
        targetedCpi: '',
        budget: '',
        dailyCap: '',
        allCities: true,
      },
    };
  },
  computed: {
    campaignRules() {
      return {
        targetedCpi: {
          ...requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
          type: 'string',
        },
        budget: {
          ...requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
          type: 'string',
        },
      };
    },
    creditIsLessThanPrice() {
      return this.credit < this.campaignModel.budget;
    },
  },
  created() {
    this.resetController.onReset(this.reset);
  },
  beforeDestroy() {
    this.resetController.removeOnReset(this.reset);
  },
  methods: {
    submitForm() {
      if (!this.isValid('campaignModel') || this.creditIsLessThanPrice) {
        return false;
      }

      this.$emit('submit', {
        ...this.campaignModel,
        dailyCap: Number(this.campaignModel.dailyCap) || 0,
      });
    },
    reset() {
      this.resetForm('campaignModel');
    },
  },
};
</script>

<style lang="scss">
.add-discovery-campaign-city-and-price-setting {
  &__back {
    font-size: 1rem;
    color: $lb-color-secondary;

    &:hover {
      color: lighten($lb-color-secondary, 5%);
    }
  }

  &__budget-error {
    margin-bottom: $global-margin;
  }
}
</style>
